import React from 'react';

const Terms = () => {
  return (
    <div className="container section">
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', padding: '3rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <h1 className="section-title" style={{ marginBottom: '2rem', textAlign: 'left' }}>Terms & Conditions</h1>
        
        <div style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563' }}>
          <p style={{ marginBottom: '1.5rem', fontSize: '0.9rem', color: '#6b7280' }}>Last updated: January 1, 2026</p>

          <p style={{ marginBottom: '1.5rem' }}>
            Please read these Terms and Conditions carefully before using the Sunshine Travels website or booking any of our services.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>1. Booking and Payments</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            All bookings are subject to availability. A deposit of 30% of the total tour cost is required to confirm a booking. The remaining balance must be paid at least 30 days prior to the departure date. We accept major credit cards and bank transfers.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>2. Cancellations and Refunds</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            If you need to cancel your trip, you must notify us in writing. The cancellation fee depends on the date we receive the notice:
            <br/>- More than 30 days before departure: Full refund minus a $50 processing fee.
            <br/>- 15 to 29 days before departure: 50% refund.
            <br/>- Less than 15 days before departure: No refund.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>3. Health and Fitness</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            It is your responsibility to ensure you are physically fit to participate in the booked activities. Some of our high-altitude treks require excellent physical conditioning. Please consult your doctor before booking if you have any pre-existing medical conditions.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>4. Itinerary Changes</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            While we strive to adhere strictly to the planned itinerary, weather conditions, political situations, or other unforeseen events may force us to alter the schedule. Sunshine Travels reserves the right to modify itineraries for the safety and well-being of the participants.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>5. Liability</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            Sunshine Travels is not liable for any injuries, losses, or damages incurred during the trip. Participants are strongly advised to purchase comprehensive travel insurance that covers medical emergencies, trip cancellations, and adventure activities.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
